import FetchApiError from "@/lib/openapi/api-error";
import {
    ExtractFetchParams,
    ExtractMutationOptions,
    ExtractResponse,
    useMutationRequest,
} from "@/lib/openapi/hooks";
import { useQueryClient } from "@tanstack/react-query";

export type UpdateFeatureFlagsResponse = ExtractResponse<
  "telegramAuthorization",
  "/update-feature-flags",
  "put"
>;

export type UpdateFeatureFlagsFetchParams = ExtractFetchParams<
  "telegramAuthorization",
  "/update-feature-flags",
  "put"
>;

export const useUpdateFeatureFlagsMutate = ({
  queryOptions,
}: {
  queryOptions?: ExtractMutationOptions<
    UpdateFeatureFlagsResponse,
    FetchApiError,
    UpdateFeatureFlagsFetchParams,
    unknown
  >;
} = {}) => {
  const queryClient = useQueryClient();

  return useMutationRequest("telegramAuthorization", "/update-feature-flags", {
    method: "put",
    queryOptions: {
      ...(queryOptions || {}),
      onSuccess: (...params) => {
        queryClient.invalidateQueries({
          queryKey: ["telegramAuthorization", "me"],
        });
        queryClient.invalidateQueries({
          queryKey: ["telegramAuthorization", "initial"],
        });
        return queryOptions?.onSuccess?.(...params);
      }
    }
  });
};

export default useUpdateFeatureFlagsMutate;
